import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { STATUS, money, fmtDateTime, fmtDay } from "@/lib/booking";
import { Card } from "./adminUI";
import { BookingActions } from "./BookingActions";

function History({ id }) {
    const [rows, setRows] = useState(null);
    if (rows === null) {
        supabase.from("booking_status_history").select("*").eq("booking_id", id).order("created_at")
            .then(({ data }) => setRows(data || []));
        return <p className="text-xs text-dim">Carregando histórico…</p>;
    }
    return (
        <ul className="space-y-1 text-xs text-dim" data-testid={`booking-history-${id}`}>
            {rows.map((h) => (
                <li key={h.id}>{fmtDateTime(h.created_at)} · {STATUS[h.from_status] || "—"} → <strong>{STATUS[h.to_status]}</strong>
                    {h.changed_by_email ? ` · ${h.changed_by_email}` : h.changed_by ? " · admin" : " · site"}{h.note ? ` · ${h.note}` : ""}</li>
            ))}
        </ul>
    );
}

export function BookingCard({ b, tour, slot, slots, role }) {
    const [open, setOpen] = useState(false);
    const when = slot ? fmtDateTime(slot.starts_at) : b.desired_date ? `${fmtDay(b.desired_date)} (a combinar)` : "—";
    const phone = (b.customer_phone || "").replace(/\D/g, "");
    return (
        <Card className="space-y-3" >
            <div className="flex flex-wrap items-start justify-between gap-3" data-testid={`booking-card-${b.code}`}>
                <div>
                    <h2 className="font-display font-bold">{b.customer_name} <span className="font-mono2 text-xs text-dim">{b.code}</span></h2>
                    <p className="text-xs text-dim">{tour?.title || "Experiência"} · {when}</p>
                </div>
                <span className="rounded-full border border-neon-cyan/30 px-3 py-1 text-xs text-neon-cyan" data-testid={`booking-status-${b.code}`}>{STATUS[b.status] || b.status}</span>
            </div>
            <p className="break-words text-xs text-dim">{b.customer_email} · <a className="text-neon-cyan" href={`https://wa.me/${phone.length <= 11 ? "55" + phone : phone}`} target="_blank" rel="noreferrer">{b.customer_phone}</a>
                {b.customer_birthdate ? ` · nasc. ${fmtDay(b.customer_birthdate)}` : ""}</p>
            <p className="text-sm">{b.adults} adulto(s){b.children_paid ? ` + ${b.children_paid} criança(s)` : ""}{b.children_free ? ` + ${b.children_free} gratuita(s)` : ""} ·
                Total <strong>{money(b.total)}</strong> · Pago {money(b.paid_amount - b.refunded_amount)} · Sinal {money(b.deposit_amount)} · Saldo {money(Math.max(0, b.total - b.paid_amount))}</p>
            {b.addons?.length > 0 && <p className="text-xs text-dim">Adicionais: {b.addons.map((a) => `${a.title} × ${a.qty}`).join(", ")}</p>}
            {b.coupon_code && <p className="text-xs text-dim">Cupom: {b.coupon_code} (- {money(b.discount_total)})</p>}
            {b.customer_notes && <p className="text-xs text-dim">Observações: {b.customer_notes}</p>}
            <BookingActions b={b} slots={slots} role={role} />
            <button className="text-xs text-neon-cyan" onClick={() => setOpen(!open)} data-testid={`booking-history-toggle-${b.code}`}>{open ? "Ocultar histórico" : "Ver histórico"}</button>
            {open && <History id={b.id} />}
        </Card>
    );
}
